export const GET_LIST_OF_ACCTS = 'get_list_of_accts';
export const GET_LIST_OF_ACCTS_SUCCESSFUL = 'get_list_of_accts_successful';
export const GET_LIST_OF_ACCTS_FAILED = 'get_list_of_accts_failed';